/**
 * MDI icon paths keyed by kebab-case name (Material Community Icons parity with app).
 */
import {
  mdiViewDashboard,
  mdiAccountGroup,
  mdiAccountPlus,
  mdiMenu,
  mdiClose,
  mdiLogout,
  mdiShieldAccount,
  mdiChevronDown,
  mdiChevronUp,
  mdiChevronRight,
  mdiLifebuoy,
  mdiEmail,
  mdiBullhorn,
  mdiSilverwareForkKnife,
  mdiDumbbell,
  mdiCog,
  mdiMagnify,
  mdiEye,
  mdiEyeOff,
  mdiPlus,
  mdiPencil,
  mdiDelete,
  mdiCheck,
  mdiCheckCircle,
  mdiAlert,
  mdiAlertCircle,
  mdiInformation,
  mdiSend,
  mdiRefresh,
  mdiContentCopy,
  mdiFilter,
  mdiDownload,
  mdiUpload,
  mdiArrowLeft,
  mdiHome,
  mdiStar,
  mdiInstagram,
  mdiFacebook,
  mdiApple,
  mdiCellphone,
  mdiShield,
  mdiLock,
  mdiCloseCircle,
  mdiGavel,
  mdiBriefcase,
  mdiChartBar,
  mdiFileDocument,
  mdiHandshake,
  mdiTrendingUp,
  mdiChartLine,
  mdiShieldCheck,
  mdiAccount,
  mdiCalendarMonth,
  mdiHeart,
  mdiMedicalBag,
  mdiRobot,
  mdiBell,
  mdiCreditCard,
  mdiHelpCircle,
  mdiHeadset,
  mdiClockOutline,
  mdiWater,
  mdiFlag,
  mdiFire,
  mdiPalette,
  mdiShape,
  mdiPhone,
  mdiTicket,
  mdiHistory,
  mdiCash,
  mdiTicketPercent,
  mdiAccountMultiple,
  mdiAccountCog,
  mdiMessageText,
  mdiFood,
  mdiFoodApple,
  mdiCoffee,
  mdiBreadSlice,
  mdiBarley,
  mdiEgg,
  mdiFish,
  mdiIceCream,
  mdiLeaf,
  mdiGrass,
  mdiBottleWine,
  mdiGlassCocktail,
  mdiBeer,
  mdiCup,
  mdiBlender,
  mdiPotSteam,
  mdiHamburger,
  mdiPizza,
  mdiCookie,
  mdiCake,
  mdiOil,
  mdiBottleTonic,
  mdiFlask,
  mdiTree,
  mdiFlower,
  mdiFoodVariant,
  mdiBowlMix,
  mdiFoodDrumstick,
  mdiHelp,
  mdiCalendar,
  mdiLink,
  mdiOpenInNew,
  mdiPlay,
  mdiPause,
  mdiStop,
  mdiImage,
  mdiCamera,
  mdiMapMarker,
  mdiWeb,
  mdiCodeTags,
  mdiDatabase,
  mdiServer,
  mdiCloudUpload,
  mdiCloudDownload,
  mdiBellRing,
  mdiAccountArrowRight,
  mdiPercent,
  mdiCurrencyUsd,
  mdiReceipt,
  mdiClipboardList,
  mdiPoll,
  mdiForum,
  mdiThumbUp,
  mdiThumbDown,
  mdiBlockHelper,
  mdiPencilOutline,
  mdiDeleteOutline,
  mdiPlusCircle,
  mdiMinus,
  mdiDotsVertical,
  mdiSort,
  mdiArrowUp,
  mdiArrowDown,
  mdiCalendarClock,
  mdiFoodOff,
  mdiScale,
  mdiTarget,
  mdiLightningBolt,
  mdiBrain,
  mdiBookOpen,
  mdiSchool,
  mdiCertificate,
  mdiTrophy,
  mdiEmoticonHappy,
  mdiEmoticonSad,
  mdiWeatherSunny,
  mdiWhiteBalanceSunny,
  mdiMoonWaningCrescent,
  mdiSleep,
  mdiRun,
  mdiWalk,
  mdiBike,
  mdiSwim,
  mdiYoga,
  mdiWeight,
  mdiRuler,
  mdiHeartPulse,
  mdiHospital,
  mdiPill,
  mdiNeedle,
  mdiBandage,
  mdiTooth,
  mdiEyeCheck,
  mdiAccountSearch,
  mdiAccountCheck,
  mdiAccountRemove,
  mdiAccountOff,
  mdiKey,
  mdiKeyVariant,
  mdiLogin,
  mdiLogoutVariant,
  mdiCellphoneCheck,
  mdiRocketLaunch,
  mdiGoogle,
  mdiMicrosoft,
} from '@mdi/js';

export const iconMap = {
  'view-dashboard': mdiViewDashboard,
  dashboard: mdiViewDashboard,
  'account-group': mdiAccountGroup,
  people: mdiAccountGroup,
  'account-plus': mdiAccountPlus,
  'person-add': mdiAccountPlus,
  menu: mdiMenu,
  close: mdiClose,
  logout: mdiLogout,
  'admin-panel-settings': mdiShieldAccount,
  'shield-account': mdiShieldAccount,
  'expand-more': mdiChevronDown,
  'expand-less': mdiChevronUp,
  'chevron-right': mdiChevronRight,
  'navigate-next': mdiChevronRight,
  support: mdiLifebuoy,
  'support-agent': mdiHeadset,
  email: mdiEmail,
  campaign: mdiBullhorn,
  restaurant: mdiSilverwareForkKnife,
  food: mdiSilverwareForkKnife,
  'fitness-center': mdiDumbbell,
  dumbbell: mdiDumbbell,
  settings: mdiCog,
  cog: mdiCog,
  search: mdiMagnify,
  visibility: mdiEye,
  eye: mdiEye,
  'visibility-off': mdiEyeOff,
  add: mdiPlus,
  edit: mdiPencil,
  delete: mdiDelete,
  check: mdiCheck,
  'check-circle': mdiCheckCircle,
  warning: mdiAlert,
  error: mdiAlertCircle,
  'alert-circle': mdiAlertCircle,
  info: mdiInformation,
  information: mdiInformation,
  send: mdiSend,
  refresh: mdiRefresh,
  'content-copy': mdiContentCopy,
  filter: mdiFilter,
  download: mdiDownload,
  upload: mdiUpload,
  'arrow-back': mdiArrowLeft,
  home: mdiHome,
  star: mdiStar,
  instagram: mdiInstagram,
  facebook: mdiFacebook,
  apple: mdiApple,
  'phone-android': mdiCellphone,
  cellphone: mdiCellphone,
  shield: mdiShield,
  'shield-check': mdiShieldCheck,
  security: mdiShieldCheck,
  lock: mdiLock,
  cancel: mdiCloseCircle,
  gavel: mdiGavel,
  'business-center': mdiBriefcase,
  business: mdiBriefcase,
  'bar-chart': mdiChartBar,
  analytics: mdiChartLine,
  description: mdiFileDocument,
  handshake: mdiHandshake,
  'trending-up': mdiTrendingUp,
  'chart-line': mdiTrendingUp,
  group: mdiAccountGroup,
  'account-circle': mdiAccount,
  account: mdiAccount,
  'calendar-month': mdiCalendarMonth,
  calendar: mdiCalendar,
  favorite: mdiHeart,
  heart: mdiHeart,
  'local-pharmacy': mdiMedicalBag,
  'medical-bag': mdiMedicalBag,
  medication: mdiPill,
  pill: mdiPill,
  robot: mdiRobot,
  'smart-toy': mdiRobot,
  notifications: mdiBell,
  bell: mdiBell,
  'credit-card': mdiCreditCard,
  'help-outline': mdiHelpCircle,
  'help-circle': mdiHelpCircle,
  schedule: mdiClockOutline,
  'access-time': mdiClockOutline,
  'water-drop': mdiWater,
  water: mdiWater,
  flag: mdiFlag,
  'local-fire-department': mdiFire,
  fire: mdiFire,
  palette: mdiPalette,
  category: mdiShape,
  'phone-iphone': mdiCellphone,
  phone: mdiPhone,
  ticket: mdiTicket,
  history: mdiHistory,
  money: mdiCash,
  cash: mdiCash,
  'local-offer': mdiTicketPercent,
  coupon: mdiTicketPercent,
  admins: mdiAccountCog,
  'account-cog': mdiAccountCog,
  'message-logs': mdiMessageText,
  ingredients: mdiFood,
  meals: mdiSilverwareForkKnife,
  activities: mdiDumbbell,
  surveys: mdiPoll,
  poll: mdiPoll,
  // Ingredients categories
  local_cafe: mdiCoffee,
  coffee: mdiCoffee,
  bread: mdiBreadSlice,
  bakery_dining: mdiBreadSlice,
  grain: mdiBarley,
  egg: mdiEgg,
  egg_alt: mdiEgg,
  set_meal: mdiFish,
  lunch_dining: mdiFoodDrumstick,
  kebab_dining: mdiFoodDrumstick,
  protein: mdiDumbbell,
  apple: mdiFoodApple,
  spa: mdiLeaf,
  grass: mdiGrass,
  yard: mdiTree,
  park: mdiTree,
  nature: mdiTree,
  eco: mdiTree,
  leaf: mdiLeaf,
  energy_savings_leaf: mdiLeaf,
  local_florist: mdiFlower,
  filter_vintage: mdiFlower,
  icecream: mdiIceCream,
  ice_cream: mdiIceCream,
  candy: mdiCake,
  cookie: mdiCookie,
  cake: mdiCake,
  fastfood: mdiHamburger,
  local_pizza: mdiPizza,
  oil: mdiOil,
  opacity: mdiOil,
  local_drink: mdiCup,
  milk: mdiCup,
  emoji_food_beverage: mdiCup,
  sports_bar: mdiBeer,
  local_bar: mdiGlassCocktail,
  liquor: mdiBottleWine,
  blender: mdiBlender,
  kitchen: mdiPotSteam,
  rice_bowl: mdiBowlMix,
  breakfast_dining: mdiFoodVariant,
  dinner_dining: mdiFoodVariant,
  science: mdiFlask,
  inventory: mdiFood,
  'block': mdiBlockHelper,
  'edit-note': mdiPencilOutline,
  'delete-outline': mdiDeleteOutline,
  'add-circle': mdiPlusCircle,
  link: mdiLink,
  'open-in-new': mdiOpenInNew,
  play: mdiPlay,
  pause: mdiPause,
  stop: mdiStop,
  image: mdiImage,
  camera: mdiCamera,
  'map-marker': mdiMapMarker,
  web: mdiWeb,
  database: mdiDatabase,
  'cloud-upload': mdiCloudUpload,
  percent: mdiPercent,
  receipt: mdiReceipt,
  'clipboard-list': mdiClipboardList,
  forum: mdiForum,
  'thumb-up': mdiThumbUp,
  'thumb-down': mdiThumbDown,
  scale: mdiScale,
  target: mdiTarget,
  'lightning-bolt': mdiLightningBolt,
  brain: mdiBrain,
  book: mdiBookOpen,
  trophy: mdiTrophy,
  run: mdiRun,
  walk: mdiWalk,
  weight: mdiWeight,
  'heart-pulse': mdiHeartPulse,
  hospital: mdiHospital,
  needle: mdiNeedle,
  'account-search': mdiAccountSearch,
  'account-check': mdiAccountCheck,
  key: mdiKey,
  login: mdiLogin,
  'cellphone-check': mdiCellphoneCheck,
  rocket: mdiRocketLaunch,
  google: mdiGoogle,
  microsoft: mdiMicrosoft,
  'dots-vertical': mdiDotsVertical,
  sort: mdiSort,
  'arrow-up': mdiArrowUp,
  'arrow-down': mdiArrowDown,
  'calendar-clock': mdiCalendarClock,
  'food-off': mdiFoodOff,
  'bell-ring': mdiBellRing,
  'account-arrow-right': mdiAccountArrowRight,
  'currency-usd': mdiCurrencyUsd,
  'weather-sunny': mdiWeatherSunny,
  'white-balance-sunny': mdiWhiteBalanceSunny,
  sleep: mdiSleep,
  swim: mdiSwim,
  yoga: mdiYoga,
  ruler: mdiRuler,
  tooth: mdiTooth,
  'eye-check': mdiEyeCheck,
  'account-remove': mdiAccountRemove,
  'account-off': mdiAccountOff,
  'key-variant': mdiKeyVariant,
  'logout-variant': mdiLogoutVariant,
  'cloud-download': mdiCloudDownload,
  'code-tags': mdiCodeTags,
  server: mdiServer,
  school: mdiSchool,
  certificate: mdiCertificate,
  'emoticon-happy': mdiEmoticonHappy,
  'emoticon-sad': mdiEmoticonSad,
  bike: mdiBike,
  bandage: mdiBandage,
  'question-mark': mdiHelp,
  'help': mdiHelp,
  minus: mdiMinus,
  'plus-circle': mdiPlusCircle,
};

export function getIconPath(name) {
  if (!name) return null;
  const key = String(name).toLowerCase().replace(/_/g, '-');
  return iconMap[key] || iconMap[name] || null;
}
